import {LocalDate} from '@js-joda/core';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import RefreshIcon from '@material-ui/icons/Refresh';
import {useSnackbar} from 'notistack';
import React, {useState} from 'react';
import {Employee} from '../Utils/EmployeeSchedulesCompiler';
import {useScheduleContext} from '../Utils/ScheduleContextProvider';

type Props = {
    employee : Employee;
    startDate : LocalDate;
};

const RefreshButton : React.FC<Props> = ({employee, startDate} : Props) => {
    const [refreshing, setRefreshing] = useState(false);
    const scheduleContext = useScheduleContext();
    const {enqueueSnackbar} = useSnackbar();

    const handleRefresh = async () => {
        setRefreshing(true);
        try {
            await scheduleContext.refresh(employee, startDate);
        } catch (e) {
            enqueueSnackbar('Could not refresh employee', {variant: 'error'});
            console.error(e);
        }
        setRefreshing(false);
    };

    return (
        <Tooltip title="Refresh employee schedule">
            <IconButton size="small" color="inherit" onClick={handleRefresh} disabled={refreshing}>
                <RefreshIcon/>
            </IconButton>
        </Tooltip>
    );
};

export default RefreshButton;
